module.exports = __webpack_public_path__ + "static/img/6.6f296dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/6.jpg
// module id = j42F
// module chunks = 1